import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex, Image as BaseImage, Text, ButtonFilled } from '../../../Base';
import QuizDetails, { QUIZ_DETAIL_VARIANTS } from '../../Components/QuizDetails';
import ReportTable from '../../Components/ReportTable';

const Image = styled(BaseImage)`
  display: none;
  @media screen and (min-height: 600px) {
    display: block;
  }
`;

const GradedExamResultWrapper = styled((props) => (
  <Flex flexDirection="column" alignItems="center" p={[0, 2, 3]} width={1} {...props} />
))`
  overflow: auto;
  height: 100%;
`;

const GradedExamResult = ({
  variant,
  isPass,
  passingScore,
  onStartQuiz,
  totalRound,
  remainingRound,
  studentScore,
  fullScore,
  timeSpent,
  onSeeReport,
  reports,
  onGoToNextSubsection,
  disableStartQuizButton,
  openCourseReviewModal,
  isLastSubsectionInCourse,
}) => {
  const hasReachedMaxAttempts = remainingRound === 0;

  const renderNextSubsectionButton = () => {
    if (isLastSubsectionInCourse) {
      return (
        <Flex justifyContent="center">
          <ButtonFilled
            borderRadius={100}
            width={1}
            maxWidth={343}
            onClick={openCourseReviewModal}
            pt={2}
          >
            รีวิวคอร์สเรียน
          </ButtonFilled>
        </Flex>
      );
    }
    return (
      <Flex justifyContent="center">
        <ButtonFilled
          borderRadius={100}
          width={1}
          maxWidth={343}
          onClick={onGoToNextSubsection}
          pt={2}
        >
          เรียนบทต่อไป
        </ButtonFilled>
      </Flex>
    );
  };

  return (
    <GradedExamResultWrapper>
      <Image src={'/assets/images/quiz/skooldio-quiz-result.png'} />
      <Text
        textStyle={{ _: 'heading5', md: 'heading4' }}
        fontWeight={'normal'}
        textAlign={'center'}
        mb={{ _: 1, md: 4 }}
      >
        ผลสอบรอบนี้ของคุณ
      </Text>
      <Text
        textStyle={{ _: 'heading4', md: 'heading1' }}
        fontWeight={'normal'}
        color={'primary'}
        textAlign={'center'}
        mb={{ _: 1, md: 4 }}
      >
        {isPass ? 'ผ่าน' : 'ไม่ผ่าน'}
      </Text>
      <QuizDetails
        variant={QUIZ_DETAIL_VARIANTS.RESULT}
        data={{ studentScore, fullScore, timeSpent }}
      />
      <ReportTable
        variant={variant}
        reports={reports}
        onSeeReport={onSeeReport}
        mb={{ _: 3, md: 6 }}
        minHeight="fit-content"
        passingScore={passingScore}
      />
      <Box mt={'auto'} width={'100%'} pb={{ _: 0, md: 7 }}>
        <Text textStyle={'body2'} fontWeight={'normal'} textAlign={'center'} mb={3}>
          {hasReachedMaxAttempts
            ? `คุณได้ทำแบบทดสอบนี้ครบ ${totalRound} ครั้งแล้ว`
            : `ทำได้อีก ${remainingRound}/${totalRound} ครั้ง`}
        </Text>
        {hasReachedMaxAttempts ? (
          renderNextSubsectionButton()
        ) : (
          <Flex justifyContent="center">
            <ButtonFilled
              borderRadius={100}
              width={1}
              maxWidth={343}
              onClick={onStartQuiz}
              disabled={disableStartQuizButton}
              pt={2}
            >
              ทำแบบทดสอบอีกครั้ง
            </ButtonFilled>
          </Flex>
        )}
      </Box>
    </GradedExamResultWrapper>
  );
};

GradedExamResult.propTypes = {
  variant: PropTypes.string,
  totalRound: PropTypes.number,
  remainingRound: PropTypes.number,
  studentScore: PropTypes.number,
  fullScore: PropTypes.number,
  timeSpent: PropTypes.number,
  disableStartQuizButton: PropTypes.bool,
  isPass: PropTypes.bool,
  passingScore: PropTypes.number,
  onSeeReport: PropTypes.func,
  onGoToNextSubsection: PropTypes.func,
  onStartQuiz: PropTypes.func,
  openCourseReviewModal: PropTypes.func,
  isLastSubsectionInCourse: PropTypes.bool,
  reports: PropTypes.arrayOf(
    PropTypes.shape({
      round: PropTypes.number,
      date: PropTypes.string,
      score: PropTypes.number,
      fullScore: PropTypes.number,
      id: PropTypes.string,
    })
  ),
};

export default GradedExamResult;
